export const WorkSansSemiBold = 'WorkSans-SemiBold';
export const WorkSansMedium = 'WorkSans-Medium';
export const CircularTTMedium = 'CircularTT-Medium';
